import { render, staticRenderFns } from "./asset-list.vue?vue&type=template&id=0982192e&"
import script from "./asset-list.vue?vue&type=script&lang=js&"
export * from "./asset-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports